(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initBlurText(scope = document) {
    scope.querySelectorAll('[data-rb-blur-text]:not([data-rb-ready])').forEach((heading) => {
      const label = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!label) return;

      heading.dataset.rbReady = 'true';
      heading.setAttribute('aria-label', label);
      heading.textContent = '';

      label.split(' ').forEach((word, index) => {
        const span = document.createElement('span');
        span.className = 'kp-rb-word';
        span.setAttribute('aria-hidden', 'true');
        span.style.setProperty('--kp-rb-index', index);
        span.textContent = word;
        heading.appendChild(span);
      });

      if (reducedMotion.matches) {
        heading.classList.add('kp-rb-visible');
        return;
      }

      requestAnimationFrame(() => requestAnimationFrame(() => heading.classList.add('kp-rb-visible')));
    });
  }

  function initMagnet(scope = document) {
    if (reducedMotion.matches || !window.matchMedia('(pointer: fine)').matches) return;

    scope.querySelectorAll('.kp-btn:not([data-rb-magnet-ready])').forEach((button) => {
      button.dataset.rbMagnetReady = 'true';
      button.classList.add('kp-rb-magnet');

      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        const x = (event.clientX - rect.left - rect.width / 2) * .13;
        const y = (event.clientY - rect.top - rect.height / 2) * .16;
        button.style.setProperty('--kp-rb-x', `${x.toFixed(2)}px`);
        button.style.setProperty('--kp-rb-y', `${y.toFixed(2)}px`);
      });

      button.addEventListener('pointerleave', () => {
        button.style.setProperty('--kp-rb-x', '0px');
        button.style.setProperty('--kp-rb-y', '0px');
      });
    });
  }

  function init(scope = document) {
    initBlurText(scope);
    initMagnet(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
